import React, { useState } from "react";
import styles from "./header.module.css";

const Header = () => {
  const [showHelp, setShowHelp] = useState(false);

  const closeHelp = () => setShowHelp(false);

  return (
    <>
      <div
        className={`d-flex justify-content-between align-items-center px-4 ${styles.header}`}
      >
        <img className={styles.logo} alt="CUPI" src="/cupiLogo.svg" />

        <div>
          <div
            className={`d-flex align-items-center gap-2 ${styles.title}`}
            onClick={() => setShowHelp(true)}
          >
            <div className={styles.helpWrap}>
              <img
                className={styles.supportIcon}
                alt="Support"
                src="/support.svg"
              />
            </div>
            <span style={{ fontSize: "18px" }}>Need help?</span>
          </div>
        </div>
      </div>

      <div style={{ borderBottom: "1px solid #C0C0C0" }} />
      <div className={styles.welcome}>Welcome to CUPI</div>

      {/* Overlay + Popover */}
      {showHelp && (
        <>
          <div className={styles.overlay} onClick={closeHelp}></div>
          <div className={styles.helpPopover}>
            <div
              className="d-flex justify-content-center"
              style={{ fontWeight: 600, fontSize: "20px" }}
            >
              Need Help ?
            </div>
            <div className={`${styles.popTitle} gap-2`}>
              <img src="/gmail.svg" />
              Email us: care@getcupi.com
            </div>
            <div className={`${styles.popTitle} gap-2`}>
              <img src="/phone.svg" />
              Call us: +91 9740510088
            </div>
            <div className={`${styles.popTitle} gap-2`}>
              <img src="/tele.svg" /> We are here for you from Monday -
              Saturday, 10am to 7pm.
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Header;
